import filter from "lodash/filter";
import orderBy from "lodash/orderBy";
import PropTypes from "prop-types";
import { FullWithHover } from "./FullWithHover";
import { LeftWithHover } from "./LeftWithHover";
import { MidWithHover } from "./MidWithHover";
import { RightWithHover } from "./RightWithHover";
import { Bar, themes } from "./styles";
import { getColorMap, updateScheduledPTO } from "./utils";

const ptoOrder = {
  usable: 0,
  pending: 1,
  editing: 2,
  scheduled: 3,
};

export const PTOBar = ({
  usablePTO,
  pendingPTO,
  scheduledPTO,
  editingPTO,
  completedPTO,
}) => {
  const updatedScheduledPTO = updateScheduledPTO(scheduledPTO, completedPTO);
  const totals = usablePTO + pendingPTO + updatedScheduledPTO + editingPTO;
  const ptoValues = {
    usable: parseFloat(usablePTO).toFixed(2),
    pending: parseFloat(pendingPTO).toFixed(2),
    scheduled: parseFloat(updatedScheduledPTO).toFixed(2),
    editing: parseFloat(editingPTO).toFixed(2),
  };

  const colorMap = getColorMap(usablePTO);

  const shouldPresent = filter(
    Object.keys(ptoValues),
    (ptoValue) => ptoValues[ptoValue] > 0
  );
  const ordered = orderBy(shouldPresent, (ptoValue) => ptoOrder[ptoValue]);

  switch (ordered.length) {
    case 4:
      return (
        <Bar>
          <LeftWithHover
            content={ptoValues[ordered[0]]}
            theme={themes[colorMap[ordered[0]]]}
            width={(ptoValues[ordered[0]] / totals) * 100}
            category={ordered[0]}
          />
          <MidWithHover
            content={ptoValues[ordered[1]]}
            theme={themes[colorMap[ordered[1]]]}
            width={(ptoValues[ordered[1]] / totals) * 100}
            category={ordered[1]}
          />
          <MidWithHover
            content={ptoValues[ordered[2]]}
            theme={themes[colorMap[ordered[2]]]}
            width={(ptoValues[ordered[2]] / totals) * 100}
            category={ordered[2]}
          />
          <RightWithHover
            content={ptoValues[ordered[3]]}
            theme={themes[colorMap[ordered[3]]]}
            width={(ptoValues[ordered[3]] / totals) * 100}
            category={ordered[3]}
          />
        </Bar>
      );
    case 3:
      return (
        <Bar>
          <LeftWithHover
            category={ordered[0]}
            content={ptoValues[ordered[0]]}
            theme={themes[colorMap[ordered[0]]]}
            width={(ptoValues[ordered[0]] / totals) * 100}
          />
          <MidWithHover
            category={ordered[1]}
            content={ptoValues[ordered[1]]}
            theme={themes[colorMap[ordered[1]]]}
            width={(ptoValues[ordered[1]] / totals) * 100}
          />
          <RightWithHover
            category={ordered[2]}
            content={ptoValues[ordered[2]]}
            theme={themes[colorMap[ordered[2]]]}
            width={(ptoValues[ordered[2]] / totals) * 100}
          />
        </Bar>
      );
    case 2:
      return (
        <Bar>
          <LeftWithHover
            category={ordered[0]}
            content={ptoValues[ordered[0]]}
            theme={themes[colorMap[ordered[0]]]}
            width={(ptoValues[ordered[0]] / totals) * 100}
          />
          <RightWithHover
            category={ordered[1]}
            content={ptoValues[ordered[1]]}
            theme={themes[colorMap[ordered[1]]]}
            width={(ptoValues[ordered[1]] / totals) * 100}
          />
        </Bar>
      );
    case 1:
      return (
        <Bar>
          <FullWithHover
            category={ordered[0]}
            content={ptoValues[ordered[0]]}
            theme={themes[colorMap[ordered[0]]]}
          />
        </Bar>
      );
    case 0:
      return (
        <Bar>
          <FullWithHover hasNoPTO theme={themes.default} />
        </Bar>
      );
    default:
      return null;
  }
};

PTOBar.propTypes = {
  usablePTO: PropTypes.number.isRequired,
  pendingPTO: PropTypes.number.isRequired,
  scheduledPTO: PropTypes.number.isRequired,
  editingPTO: PropTypes.number.isRequired,
  completedPTO: PropTypes.number.isRequired,
};
